import {
  NO_DASHBOARDS,
  ERROR,
  ISSUE,
  LOADING_DATA,
  LOADING,
  SUCCESS,
  SELECT,
  MODAL_SHOWN,
  SUCCESS_TEAMS,
  SUCCESS_AKB,
  SUCCESS_BOARDS,
  SUCCESS_LISTS,
  SUCCESS_FIELDS,
  SUCCESS_AREAS,
  SUCCESS_CREATE
} from './DashboardSelectorActions';

const INITIAL_STATE = {
  noDashboards: false,
  success: false,
  error: '',
  issue: '',
  akb: {},
  akbLoaded: false,
  selected: {},
  list: [],
  mapping: {},
  teams: [],
  boards: [],
  lists: [],
  fields: [],
  areas: [],
  isLoading: false,
  loadingBoards: false,
  loadingLists: false,
  loaded: false,
  newCreated: false,
  dashboardModel: undefined,
  boardsInfo: {},
  viewId: ''
};

const DashboardSelectorReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case NO_DASHBOARDS: {
      return { ...state, noDashboards: true, loaded: true, list: [], issue: '' };
    }
    case ERROR: {
      return { ...state, error: action.error };
    }
    case ISSUE: {
      return { ...state, issue: action.issue };
    }
    case LOADING: {
      return { ...state, isLoading: action.isLoading, issue: '' };
    }
    case LOADING_DATA: {
      return {
        ...state,
        loadingBoards: action.loadingType === 'boards',
        loadingLists: action.loadingType === 'lists'
      };
    }
    case SUCCESS: {
      return { ...state, noDashboards: false, list: action.data, loaded: true, issue: '' };
    }
    case SUCCESS_TEAMS: {
      return { ...state, teams: action.teams, loadingBoards: false, issue: '' };
    }
    case SUCCESS_AKB: {
      return { ...state, akb: action.data, akbLoaded: true };
    }
    case SUCCESS_BOARDS: {
      const boardsInfo = action.boardsInfo;
      let boards;
      if (boardsInfo && (boardsInfo.boardsSkip || boardsInfo.projectsSkip)) {
        boards = state.boards.concat(action.boards);
      } else {
        boards = action.boards;
      }
      return { 
        ...state,
        boards,
        boardsInfo,
        issue: '',
        loadingBoards: false
      };
    }
    case SUCCESS_LISTS: {
      return { ...state, lists: action.lists, mapping: action.mapping, loadingLists: false };
    }
    case SUCCESS_FIELDS: {
      return { ...state, fields: action.fields };
    }
    case SUCCESS_AREAS: {
      return { ...state, areas: action.areas, issue: '' };
    }
    case SUCCESS_CREATE: {
      return { ...state, newCreated: true, issue: '' };
    }
    case SELECT: {
      return { ...state, selected: action.selected, viewId: action.viewId, issue: '' };
    }
    case MODAL_SHOWN: {
      return { ...state, dashboardModel: action.model, newCreated: false };
    }
    default:
      return state;
  }
};

export default DashboardSelectorReducer;
